import React, { useState, useEffect } from "react";
import usePWAInstall from "../../hooks/usePWAInstall";
import "./InstallPWA.css";
import { FiDownload, FiX } from "react-icons/fi";

const InstallPWA = () => {
  const { isInstallable, handleInstallClick } = usePWAInstall();
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    if (isInstallable && !isDismissed) {
      // Small delay for better UX
      const timer = setTimeout(() => setIsVisible(true), 3000);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [isInstallable, isDismissed]);

  const onDismiss = () => {
    setIsVisible(false);
    setIsDismissed(true);
    // Remember dismissal for this session
    sessionStorage.setItem("pwa_dismissed", "true");
  };

  useEffect(() => {
    if (sessionStorage.getItem("pwa_dismissed")) {
      setIsDismissed(true);
    }
  }, []);

  if (!isInstallable && !isVisible) return null;

  return (
    <div className={`install-pwa-container ${isVisible ? "visible" : ""}`}>
      <div className="install-pwa-content">
        <div className="install-pwa-logo">
          <FiDownload />
        </div>
        <div className="install-pwa-text">
          <span>Cardplot Mobile</span>
          <span>Install for a better experience</span>
        </div>
        <button className="install-pwa-btn" onClick={handleInstallClick}>
          Install
        </button>
        <button className="install-pwa-close" onClick={onDismiss}>
          <FiX />
        </button>
      </div>
    </div>
  );
};

export default InstallPWA;
